module.exports = {"apiKey":"AIzaSyDKClTwmdO8LOO4mus4V9oTNrXykxTKwAs","firebase":{"apiKey":"AIzaSyCvjm9NmfL0RKHleJEOEcvfxu26yF5Y500","authDomain":"bpmbuild-uat-ds.firebaseapp.com","databaseURL":"https://bpmbuild-development.firebaseio.com","projectId":"bpmbuild-uat-ds","storageBucket":"bpmbuild-uat-ds.appspot.com","messagingSenderId":"1054380492394","appId":"1:1054380492394:web:afa50a694da6a01e3bac13","measurementId":"G-9883K3FE1H"}}


//////////////////
// WEBPACK FOOTER
// ./src/common/config/Files/uatds.json
// module id = 1446
// module chunks = 0